import * as z from "zod";

export const setCreditsYardIntegration = {
  name: "setCreditsYardIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    shopApiKey: z.string().min(1, "Shop API Key is required"),
  }),
  output: z.object({}),
};
